module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-tab"
  }, [_c('ul', {
    staticClass: "main-tab-list"
  }, [_c('li', [_c('router-link', {
    staticClass: "main-tab-fake",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Category',
        query: {
          levelOne: '',
          levelTwo: '',
          levelThree: '',
          keyWord: '',
          selectType: '',
          brandId: ''
        }
      }
    }
  }, [_vm._v("全部商品")])], 1), _vm._v(" "), _vm._l((_vm.tabArr), function(tab, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.tabChange(index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "to": {
          name: tab.path,
          query: {
            position: tab.position
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.desc) + "\n\t\t\t\t")])], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94d4bb94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexTab.vue
// module id = 545
// module chunks = 1